import { useState, useEffect, useCallback } from 'react';
import CorporateCommunicated from './interfaces/CorporateCommunicated';
import { getCorporateCommunicated } from './CorporateCommunicated.service';
import GridComponent from '../../component/grid/GridComponent.component';
import ButtonLink from '../../component/buttton/ButtonLink.component';
import Card from './components/Card.component';
import { useSnackbar } from '../../context/Snackbar';
import FormFilter from './form/FormFilter.component';
import { FormatDate } from '../../utils/format/FormatDate';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import { AxiosError } from 'axios';
import { BiChevronRight } from 'react-icons/bi';
import Grid from '@material-ui/core/Grid';

export default function CorporateCommunicatedComponent() {

    const { setSnackbar } = useSnackbar();
    const [corporateCommunicated, setCorporateCommunicated] = useState<CorporateCommunicated[]>([]);
    const [corporateCommunicatedFilter, setCorporateCommunicatedFilter] = useState<CorporateCommunicated[]>([]);
    const [request, setRequest] = useState<boolean>(true);

    useEffect(() => {
        response();
    }, [setSnackbar]);

    const response = useCallback(() => {
        getCorporateCommunicated().then(res => {
            if (res.data) {
                setCorporateCommunicated(res.data);
                setCorporateCommunicatedFilter(res.data);
            }
        }).catch((error: AxiosError) => {
            setSnackbar({ type: 'error', msg: 'Erro ao busca os comunicados!', subMsg: error.message })
        }).finally(function () {
            setRequest(false);
        });
    }, [setSnackbar]);

    const onSubmit = async (data: CorporateCommunicated) => {
        data.DataInicio = FormatDate(data.DataInicio, true);
        data.DataFim = FormatDate(data.DataFim, true);

        let communicated: CorporateCommunicated[] = [...corporateCommunicated].filter((el: CorporateCommunicated) => {

            let includesSubject: boolean = data.Assunto !== '' && el.Assunto.toLocaleLowerCase().includes(data.Assunto.toLocaleLowerCase());

            let includesDate: boolean = false;

            if (data.DataInicio && data.DataFim) {
                let includesDateInit: boolean = el.DataInicio.valueOf() >= data.DataInicio.valueOf();
                let includesDateEnd: boolean = el.DataFim.valueOf() <= data.DataFim.valueOf()
                includesDate = includesDateInit && includesDateEnd;
            }

            if (data.Assunto && data.DataInicio) {
                return includesSubject && includesDate;
            }

            return includesSubject || includesDate;
        });

        setCorporateCommunicatedFilter(!data.Assunto && !data.DataInicio ? [...corporateCommunicated] : communicated);

    };

    return (
        <>
            <GridComponent alignItems="flex-end" spacing={2} justify='space-between' >
                <GridComponent alignItems="flex-end" spacing={2} margin='20px 0px 0px 12px' >
                    <Grid item>
                        <ButtonLink title="Criar Comunicado" link='comunicado-corporativo/novo-comunicado' icon={<BiChevronRight color='#FFF' size={25} />} />
                    </Grid>
                    <Grid item>
                        <ButtonLink title="Grupos de destinatários " link='comunicado-corporativo/grupos' />
                    </Grid>
                </GridComponent>
                <Grid item>
                    <FormFilter handleSubmitForm={onSubmit} initialValues={INITIAL_VALUES} />
                </Grid>
            </GridComponent>

            <Card data={corporateCommunicatedFilter} request={request} />
        </>
    );
}
